import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const Prayer = () => {
    return (
        <>
            <Header />
            
            <Breadcrumb title="Prayer" midBreadcrumb="School" mainBreadcrumb="Prayer" ></Breadcrumb>
            <div  className='inner-page prayer-bg'>
                <div  className='container'>
                        <div  className="row"> 
                            <div  className="col-lg-4 col-md-6 col-12">
                                <article>
                                    
                                    <h3  className="subhead text-center">Our School Prayers</h3>
                                    <p  className="text-center">Our Father in heaven<br />Holy be your name,<br />Your Kingdom come<br />Your will be done on earth as in heaven&nbsp;<br />Give us today&nbsp;<br />our daily bread<br />and forgive us our sins<br />as we forgive those<br />who sin against us.<br />Do not bring us to the test<br />but deliver us from evil. Amen</p>
                                </article>
                            </div>
                            <div  className="col-lg-4 col-md-6 col-12">
                                <article>
                                    
                                    <h3  className="subhead text-center">The Pledge</h3>
                                    <p  className="text-center">India is my country. All Indians are my brothers and sisters.<br />I love my country. I am proud of its rich and varied heritage.<br />I shall always strive to be worthy of it.<br />I shall give my parents, teachers, class mates and<br />all elders, respect and treat everyone with courtesy.<br />To my country and my people, I pledge my devotion.&nbsp;<br />In their well-being and prosperity alone lies my happiness.</p>
                                </article>
                            </div>
                            <div  className="col-lg-4 col-md-6 col-12">
                                <article>
                                    
                                    <h3  className="subhead text-center">National Anthem</h3>
                                    <p  className="text-center">Jana-Gana-Mana Adhinayak Jai Hey<br />Bharat Bhagya Vidhata<br />Punjab, Sindhu, Gujrat, Maratha,<br />Drawid Utkal Banga.<br />Vindhya, Himachal, Yamuna Ganga,<br />Uchchal Jaladhi Taranga.<br />Tav Shubh Namey Jagey,<br />Tav Shubh Ashish Mangey.<br />Gahe tav Jai Gatha<br />Jana Gana Mangaldayak Jai Hey,<br />Bharat Bhagya Vidhata,<br />Jai Hey, Jai Hey, Jai Hey.<br />Jai, Jai, Jai, Jai, Hey.</p>
                                </article>
                            </div>
                            <div  className="col-lg-4 col-md-6 col-12">
                                <article>
                                    
                                    <h3  className="subhead text-center">Prayer Before Class</h3>
                                    <p  className="text-center">O Lord, we dedicate this day to you.<br />The thoughts we think; the words<br />we speak and the work we do.<br />Accept it all as our humble offering.<br />Our Father in heaven, holy be your name,<br />your kingdom come, your will be done on earth,<br />as it is in heaven. Give us this day,<br />our daily bread, and forgive us our sins,<br />as we forgive those, who sin against us.<br />Do not lead us into temptaon,<br />but deliver us from evil, Amen.</p>
                                </article>
                            </div>
                            <div  className="col-lg-4 col-md-6 col-12">
                                <article>
                                    
                                    <h3  className="subhead text-center">Prayer After Class</h3>
                                    <p  className="text-center">We give you thanks,<br />Almighty God<br />for all the benefits,<br />which we have received<br />from your bounty.<br />We are sincerely sorry,<br />for whatever offence<br />we may have committed this day.<br />And firmly resolve<br />never to offend you again.</p>
                                </article>
                            </div>
                            <div  className="col-lg-4 col-md-6 col-12">
                                <article>
                                    
                                    <h3  className="subhead text-center">At the End of the Day</h3>
                                    <p  className="text-center">O God, I love you with all my heart and above all things.<br />I am heartily sorry for having offended you, because you are so good.<br />I firmly resolve not to offend you any more and I shall do.</p>
                                </article>
                            </div>
                        </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Prayer